(function ($) {
    $.fn.tablePlayoff = function () {
        const $self = $(this);


        /**
         * Клик по группе команд в таблице пелйофф
         */
        const clickPlayoffGroupHandler = function () {
          const $playoffGroupHolder = $(this);
          $playoffGroupHolder.toggleClass('opened');
        };

        $self.on('click', '.js-card-playoff', clickPlayoffGroupHandler);

    };
})(jQuery);
